import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue } from 'bootstrap-vue'

import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';

Vue.filter('numFormat', numFormat(numeral));

import Vue2Filters from 'vue2-filters'

Vue.use(Vue2Filters);


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Vue.filter('moneyFormatter', function (value, locale, currency, symbol) {
//   if (!locale) {
//     value = Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP", minimumFractionDigits: 0 }).format(value).replace('$', '$ ');
//   } else {
//     value = Intl.NumberFormat(locale, { style: "currency", currency: currency, minimumFractionDigits: 0 }).format(value).replace(symbol, symbol + ' ');
//   }
//   return value;
// });
//
// Vue.filter('toCurrency', function (value) {
//   if (typeof value !== "number") {
//     return value;
//   }
//   var formatter = new Intl.NumberFormat('es-CL', {
//     style: 'currency',
//     currency: 'CLP',
//     minimumFractionDigits: 0
//   });
//   return formatter.format(value);
// });

Vue.use(BootstrapVue);
Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
}).$mount('#esepeMasterPlan');
